import { RemExpertResultatTNS } from "components/app/Api/ResultatRemExpertTNSProvider";
import { ApplySignedFormat } from "components/app/ApplySignedFormat";
import { AppContext } from "components/app/RemExprertProvider";
import CardBox from "components/ui/controls/card-box/card-box";
import Modal from "components/ui/modal/modal";
import { applyFormat } from "components/ui/ui-helpers";
import ContexteFiscalPageModal from "pages/audit complet/contexte fiscal/contexte fiscal pager";
import RemExpressContratFacPersoModal from "pages/audit rémunération/contrat facultatif perso";
import React, { useContext, useState } from "react";
import { FaGlobe, FaUser, FaDollarSign, FaFileInvoiceDollar, FaShieldAlt, FaChartLine, FaHome, FaReceipt, FaUserTie } from "react-icons/fa";
import { CompactFinancialOptiRem } from "../Resultat/CompactFinancialCard";

function RemExpressOptimisationRevenus(props) {
  const { Revenus, AutresRevenus, IRTotal, CotisationsFacPerso } = props;
  const context = useContext(AppContext);
  const ResultatTNS = useContext(RemExpertResultatTNS);
  const [modalContexteFiscalOpen, setmodalContexteFiscalOpen] = useState(false);
  const [modalContratFacPerso, setmodalContratFacPerso] = useState(false);
  return (
    <CardBox className="blockRoundedForce" bpad>
      <div style={{ display: "flex", flexDirection: "column", gap: "5px", width: "100%" }}>

        <CompactFinancialOptiRem
          icon={<FaChartLine />}
          title="Revenus d'activités perçus"
          valueOrigine={applyFormat(Revenus, "uint", { thousands: " ", decimal: ",", unit: " €" })}
          valueNouvelle={applyFormat(context.state.OptiRemRevPercus, "uint", { thousands: " ", decimal: ",", unit: " €" })}
          valueEcart={ApplySignedFormat(Number(context.state.OptiRemRevPercus) - Number(Revenus))}
          accentColor="#2563eb"
        />
        <CompactFinancialOptiRem
          icon={<FaHome />}
          title="Autres revenus du foyer"
          valueOrigine={applyFormat(AutresRevenus, "uint", { thousands: " ", decimal: ",", unit: " €" })}
          valueNouvelle={applyFormat(context.state.OptiRemRevenusFoyer, "uint", { thousands: " ", decimal: ",", unit: " €" })}
          valueEcart={ApplySignedFormat(Number(context.state.OptiRemRevenusFoyer) - Number(AutresRevenus))}
          accentColor="#2563eb"
        />
        <CompactFinancialOptiRem
          icon={<FaReceipt />}
          title="Impôt sur le revenu"
          valueOrigine={applyFormat(IRTotal, "uint", { thousands: " ", decimal: ",", unit: " €" })}
          valueNouvelle={applyFormat(context.state.OptiRemIRTotal, "uint", { thousands: " ", decimal: ",", unit: " €" })}
          onEdit={() => {
            setmodalContexteFiscalOpen(true);
          }}
          valueEcart={ApplySignedFormat(Number(context.state.OptiRemIRTotal) - Number(IRTotal))}
          accentColor="#dc2626"
        />
        <CompactFinancialOptiRem
          icon={<FaUserTie />}
          title="Cotisations facultatives personnelles"
          valueOrigine={applyFormat(CotisationsFacPerso, "uint", { thousands: " ", decimal: ",", unit: " €" })}
          valueNouvelle={applyFormat(Number(context.state.OptiRemCotFacPerso), "uint", { thousands: " ", decimal: ",", unit: " €" })}
          onEdit={() => {
            setmodalContratFacPerso(true);
          }}
          valueEcart={ApplySignedFormat(Number(context.state.OptiRemCotFacPerso) - Number(CotisationsFacPerso))}
          accentColor="#ea580c"
        />
      </div>

      <Modal
        width="80%"
        height="80%"
        title="Contexte fiscal"
        icon={<FaGlobe />}
        visible={modalContexteFiscalOpen}
        onClose={() => {
          context.handleCalculOptiRem("res_avant_is","OptiRemResAvtIs", "", ResultatTNS,false, context.state["OptiRemResAvtIs"]);
          setmodalContexteFiscalOpen(false);
        }}
      >
        <ContexteFiscalPageModal
          Outil="OptiRem"
          visible={modalContexteFiscalOpen}
          onClose={() => {
            context.handleCalculOptiRem("res_avant_is","OptiRemResAvtIs", "", ResultatTNS,false, context.state["OptiRemResAvtIs"]);
            setmodalContexteFiscalOpen(false);
          }}
        />
      </Modal>
      <Modal
        width="80%"
        height="80%"
        title="Paramètres"
        icon={<FaGlobe />}
        visible={modalContratFacPerso}
        onClose={() => {
           context.handleCalculOptiRem("res_avant_is","OptiRemResAvtIs", "", ResultatTNS,false, context.state["OptiRemResAvtIs"]);
          setmodalContratFacPerso(false);
        }}
      >
        <RemExpressContratFacPersoModal
          ClientConjoint={""}
          Outil="OptiRem"
          visible={modalContratFacPerso}
          onClose={() => {
            context.handleCalculOptiRem("res_avant_is","OptiRemResAvtIs", "", ResultatTNS,false, context.state["OptiRemResAvtIs"]);
            setmodalContratFacPerso(false);
          }}
        />
      </Modal>
    </CardBox>
  );
}
export default RemExpressOptimisationRevenus;
